<template>
  <div class="l-c">
    <el-form ref="ruleForm2" :model="ruleForm2" :rules="rules2" label-position="right" label-width="0"
      class="demo-ruleForm login-container" status-icon>
      <div class="login-form">
        <img class="logo" :src="require('../../assets/image/logo.png')" />
        <el-form-item prop="login_type" style="width: 100%">
          <el-select v-model="ruleForm2.login_type" style="width: 100%" placeholder="Please select login type" @change="loginTypeSel">
            <el-option value="Student" label="Student"></el-option>
            <el-option value="Advisor" label="Advisor"></el-option>
            <el-option value="SchoolAdmin" label="School Admin"></el-option>
          </el-select>
        </el-form-item>

        <!-- Email input for all user types -->
        <el-form-item prop="email" style="width: 100%">
          <el-input v-model="ruleForm2.email" type="text" auto-complete="off"
                    placeholder="Please login with your email" />
        </el-form-item>

        <!-- Login method selection (OTP vs Password) for Student and Advisor -->
        <el-form-item v-if="loginType==='Student' || loginType==='Advisor'" style="width: 100%">
          <el-radio-group v-model="loginMethod" @change="onLoginMethodChange">
            <el-radio label="otp">Login with OTP Code</el-radio>
            <el-radio label="password">Login with Password</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- OTP input for Student and Advisor when OTP method is selected -->
        <el-form-item v-if="(loginType==='Student' || loginType==='Advisor') && loginMethod==='otp'" prop="verify_code" style="width: 100%">
          <el-input v-model="ruleForm2.verify_code" auto-complete="off" placeholder="Please enter the code"
            type="text" >
            <el-button slot="suffix" class="send_code" @click="sendCode" :disabled="countdown > 0">
              {{ countdown > 0 ? `Resend (${countdown}s)` : 'Send Code' }}
            </el-button>
          </el-input>
        </el-form-item>

        <!-- Password input for Student and Advisor when password method is selected, or for School Admin -->
        <el-form-item v-if="(loginType==='Student' || loginType==='Advisor') && loginMethod==='password'" prop="password" style="width: 100%">
          <el-input v-model="ruleForm2.password" auto-complete="off" placeholder="Please enter your password"
            type="password" />
        </el-form-item>

        <!-- Password input for School Admin (always shows password) -->
        <el-form-item v-if="loginType==='SchoolAdmin'" prop="password" style="width: 100%">
          <el-input v-model="ruleForm2.password" auto-complete="off" placeholder="Please enter your password"
            type="password" />
        </el-form-item>

        <!-- Help links section -->
        <div class="help-links" v-if="loginType==='Student' || loginType==='Advisor'">
          <span v-if="loginMethod==='otp'" class="help-link" @click="showOtpHelp">
            Can't receive our OTP emails?
          </span>
          <span v-if="loginMethod==='password'" class="help-link" @click="showForgotPassword">
            Forgot your password?
          </span>
        </div>
        <div class="help-links" v-if="loginType==='SchoolAdmin'">
          <span class="help-link" @click="showForgotPassword">
            Forgot your password?
          </span>
        </div>

        <span v-if="!!error_text" style="color: red" class="error_text">{{
          error_text
          }}</span>

        <!-- Terms and Conditions Checkbox -->
        <div class="terms-checkbox">
          <el-checkbox v-model="agreedToTerms">
            I have read and agree to the
            <span class="terms-link" @click.stop="openTermsAndConditions">Terms and Conditions</span>
            and
            <span class="terms-link" @click.stop="openPrivacyPolicy">Privacy Policy</span>
          </el-checkbox>
        </div>

        <el-form-item style="width: 100%">
          <el-button :loading="logining" type="primary" style="width: 100%" @click="submit">Login</el-button>
        </el-form-item>
      </div>
    </el-form>

    <!-- OTP Help Dialog -->
    <el-dialog
      title="Can't receive OTP emails?"
      :visible.sync="otpHelpDialogVisible"
      width="500px"
      :close-on-click-modal="true">
      <div class="help-dialog-content">
        <p><strong>Here are some tips to help you receive OTP emails:</strong></p>
        <ol>
          <li><strong>Check your spam/junk folder:</strong> OTP emails might be categorized as spam by your email system. Please check your spam folder or trash folder.</li>
          <li><strong>Email security blocking:</strong> If your email security system blocks our emails, you can consider using another email address for login.</li>
          <li><strong>Use password instead:</strong> If you have set up a password before, you can switch to "Login with Password" option above.</li>
          <li><strong>Need a password?</strong> If you have never set up a password and cannot receive OTP emails, please send an email to <a href="mailto:contact@eae.international">contact@eae.international</a> from your registered email address, requesting password setup assistance. We will send you a password setting link after verifying your possession of the email address for your account.</li>
        </ol>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="otpHelpDialogVisible = false">Got it</el-button>
      </span>
    </el-dialog>

    <!-- Forgot Password Dialog -->
    <el-dialog
      title="Reset Your Password"
      :visible.sync="forgotPasswordDialogVisible"
      width="500px"
      :close-on-click-modal="false">
      <div class="forgot-password-content">
        <p>We will send a password reset link to your email address. Please fill in the following information to verify your identity:</p>
        <el-form ref="resetForm" :model="resetForm" label-position="top">
          <el-form-item label="Email" required>
            <el-input v-model="resetForm.email" placeholder="Your registered email"></el-input>
          </el-form-item>
          <el-form-item label="Last Name (Family Name) in English" required>
            <el-input v-model="resetForm.lastName" placeholder="Your last name in English"></el-input>
          </el-form-item>
          <el-form-item label="Given Name (First Name) in English" required>
            <el-input v-model="resetForm.givenName" placeholder="Your given name in English"></el-input>
          </el-form-item>
          <el-form-item label="Account Type" required>
            <el-select v-model="resetForm.userType" style="width: 100%">
              <el-option value="student" label="Student"></el-option>
              <el-option value="advisor" label="Advisor"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="forgotPasswordDialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="sendingResetLink" @click="sendResetLink">Send Reset Link</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { loginByAdvisor, loginByAccountAdmin, createLoginOPT, loginByStudentV2, loginByStudentWithPassword, loginByAdvisorWithPassword, sendPasswordResettingLink, getStudentInfoV1 } from "../../api/eae";
import {
  setAccountContinent,
  setUserId,
  setUserName,
  setUserAccountCountry,
  setUserType,
  setAccountId,
  setAccountName
} from "../../utils/store";

export default {
  name: "Login",
  data() {
    return {
      error_text: "",
      logining: false,
      countdown: 0,
      countdownTimer: null,
      loginMethod: 'otp', // 'otp' or 'password'
      ruleForm2: {
        email: "",
        password: "",
        login_type: "Student",
        verify_code: "",
      },
      loginType: 'Student',
      rules2: {
        email: [
          {
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Please enter your password",
            trigger: "blur",
          },
        ],
        login_type: [
          {
            required: true,
            message: "Please select login type",
            trigger: "blur",
          },
        ],
      },
      // OTP Help Dialog
      otpHelpDialogVisible: false,
      // Forgot Password Dialog
      forgotPasswordDialogVisible: false,
      sendingResetLink: false,
      resetForm: {
        email: '',
        lastName: '',
        givenName: '',
        userType: 'student'
      },
      // Terms and Conditions
      agreedToTerms: false
    };
  },
  mounted(){
    console.log('Login page loaded')
    this.checkAutoLogin()
  },
  beforeDestroy() {
    // Clear countdown timer if component is destroyed
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    checkAutoLogin() {
      const query = this.$route.query
      const { student_id, login_type, application_id, redirect_path } = query
      console.log('student_id' + student_id)
        console.log('login_type' + login_type)
          console.log('application_id' + application_id)
            console.log('redirect_path' + redirect_path)
      if (student_id && login_type && application_id && redirect_path && login_type.toLowerCase() === '学生') {
        this.logining = true
        getStudentInfoV1(student_id).then((res) => {
          this.logining = false
          let result = res.data
          if (result.code === 0) {
            const data = result.data
            setUserId(data._id.$id)
            let account_country = ''
            if (data.account_country) {
              account_country = data.account_country
            }
            setUserAccountCountry(account_country)
            const user_name =
              data.student_givenName_pinyin.charAt(0).toUpperCase() + data.student_givenName_pinyin.slice(1) + ' ' + data.student_lastName_pinyin.charAt(0).toUpperCase() + data.student_lastName_pinyin.slice(1)
            setUserName(user_name)
            setUserType('student')
            setAccountName(data.account_name)
            setAccountContinent(data.account_continent)
            setAccountId(data.account_id)
            this.$UserData.user_name = user_name
            this.$UserData.account_country = account_country
            this.$UserData.account_name = data.account_name
            this.$UserData.account_continent = data.account_continent
            this.$router.push("/home/news&updates");
            setTimeout(()=>{this.$router.push('/home/program-order?application_id=' + application_id)},500)
          } else {
            // this.$message.error(result.msg || 'Auto login failed, please login manually.')
          }
        }).catch(() => {
          this.logining = false
          this.$message.error('Network error. Please login manually.')
        })
      }
    },
    loginTypeSel(val){
      console.log(val,'loginType')
      this.loginType = val
      // Reset login method to OTP for Student/Advisor
      if(val === 'Student' || val === 'Advisor') {
        this.loginMethod = 'otp'
      }
      // Update reset form user type
      if(val === 'Student') {
        this.resetForm.userType = 'student'
      } else if(val === 'Advisor') {
        this.resetForm.userType = 'advisor'
      } else {
        this.resetForm.userType = 'schoolAdmin'
      }
    },
    onLoginMethodChange(val) {
      // Clear error text when switching login method
      this.error_text = ''
    },
    openTermsAndConditions() {
      const routeData = this.$router.resolve({ path: '/terms-and-conditions' });
      window.open(routeData.href, '_blank');
    },
    openPrivacyPolicy() {
      const routeData = this.$router.resolve({ path: '/privacy-policy' });
      window.open(routeData.href, '_blank');
    },
    showOtpHelp() {
      this.otpHelpDialogVisible = true
    },
    showForgotPassword() {
      // Pre-fill email if already entered
      this.resetForm.email = this.ruleForm2.email
      this.forgotPasswordDialogVisible = true
    },
    sendResetLink() {
      // Validate reset form
      if(!this.resetForm.email) {
        this.$message.error('Please enter your email')
        return
      }
      if(!this.resetForm.lastName) {
        this.$message.error('Please enter your last name')
        return
      }
      if(!this.resetForm.givenName) {
        this.$message.error('Please enter your given name')
        return
      }

      this.sendingResetLink = true
      sendPasswordResettingLink(
        this.resetForm.email,
        this.resetForm.userType,
        this.resetForm.lastName,
        this.resetForm.givenName
      ).then(res => {
        this.sendingResetLink = false
        let result = res.data
        if(result.code === 0) {
          this.$message.success('Password reset link sent! Please check your email.')
          this.forgotPasswordDialogVisible = false
          // Clear form
          this.resetForm = {
            email: '',
            lastName: '',
            givenName: '',
            userType: this.resetForm.userType
          }
        } else {
          this.$message.error(result.msg || 'Failed to send reset link')
        }
      }).catch(err => {
        this.sendingResetLink = false
        this.$message.error('Network error. Please try again.')
      })
    },
    sendCode(){
      if (this.ruleForm2.email == "") {
        this.$message.error("Please enter your email");
        return;
      }
      if (this.countdown > 0) {
        return; // Prevent sending if countdown is active
      }
      let login_type = 'student'
      if(this.loginType == 'Advisor') {
        login_type = 'advisor'
      }
      createLoginOPT(this.ruleForm2.email, login_type).then((res) => {
        let result = res.data
        if(result.code === 0){
          this.$message.success('Sent Successfully');
          // Start countdown
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.countdownTimer);
              this.countdownTimer = null;
            }
          }, 1000);
        }else{
          this.$message.error(result.msg || 'Verification code sent failed. Please try again.')
        }
      })
    },
    submit() {
      this.logining = false;
      this.error_text = "";

      // Validate Terms and Conditions agreement
      if (!this.agreedToTerms) {
        this.$alert('Please read and agree to the Terms and Conditions and Privacy Policy to proceed with login.', 'Agreement Required', {
          confirmButtonText: 'OK',
          type: 'warning',
          callback: () => {
            // Focus on the checkbox after alert is closed
            this.$nextTick(() => {
              const checkbox = this.$el.querySelector('.terms-checkbox .el-checkbox__input');
              if (checkbox) {
                checkbox.focus();
              }
            });
          }
        });
        return;
      }

      // Validate email for all login types
      if (this.ruleForm2.email == "") {
        this.$message.error("Please enter your email");
        return;
      }

      // For Student/Advisor with OTP
      if((this.loginType === "Student" || this.loginType === "Advisor") && this.loginMethod === 'otp') {
        if (this.ruleForm2.verify_code == "") {
          this.$message.error("Please enter the code");
          return;
        }
      }

      // For password login
      if((this.loginType === "Student" || this.loginType === "Advisor") && this.loginMethod === 'password') {
        if (this.ruleForm2.password == "") {
          this.$message.error("Please enter your password");
          return;
        }
      }

      // For School Admin
      if(this.loginType === "SchoolAdmin") {
        if (this.ruleForm2.password == "") {
          this.$message.error("Please enter your password");
          return;
        }
      }

      // Hardcoded admin credentials (for testing)
      if (
        this.ruleForm2.email === "admin" &&
        this.ruleForm2.password === "yiquanTodo"
      ) {
        setUserId("admin");
        setUserName("admin");
        setUserType("admin");
        setUserAccountCountry("China");
        setAccountContinent("Asia");
        this.$UserData.user_name = "admin";
        this.$UserData.account_country = "China";
        this.$UserData.account_continent = "Asia";
        this.$router.push("/home/adminform");
        return;
      }

      this.logining = true;

      // School Admin login
      if (this.ruleForm2.login_type == 'SchoolAdmin') {
        loginByAccountAdmin(this.ruleForm2.email, this.ruleForm2.password).then((res) => {
          this.logining = false;
          let result = res.data
          if (result.code == 0) {
            setUserId(result.data._id.$id);
            let account_country = "China";
            if (result.data.account_country) {
              account_country = result.data.account_country;
            }
            setUserAccountCountry(account_country);
            let user_name = result.data.account_nameEN;
            if (!user_name || user_name == '') {
              user_name = result.data.account_name;
            }
            setUserName(user_name);
            setUserType("schoolAdmin");
            setAccountId(result.data._id.$id);
            this.$UserData.user_name = user_name;
            this.$UserData.account_country = account_country;
            const account_continent = result.data.account_continent || "Asia";
            setAccountContinent(account_continent);
            this.$UserData.account_continent = account_continent;
            this.$router.push("/home/news&updates");
          } else {
            this.error_text = result.msg;
          }
        }).catch(() => {
          this.logining = false;
          this.error_text = "Network error. Please try again.";
        })
      }
      // Advisor login
      else if (this.ruleForm2.login_type === "Advisor") {
        if(this.loginMethod === 'otp') {
          // OTP login
          loginByAdvisor({
            contact_email: this.ruleForm2.email,
            verify_code: this.ruleForm2.verify_code,
          }).then((res1) => {
            this.logining = false;
            let result1 = res1.data;
            if (result1.code == 0) {
              this.handleAdvisorLoginSuccess(result1.data);
            } else {
              this.error_text = result1.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        } else {
          // Password login
          loginByAdvisorWithPassword(this.ruleForm2.email, this.ruleForm2.password).then((res1) => {
            this.logining = false;
            let result1 = res1.data;
            if (result1.code == 0) {
              this.handleAdvisorLoginSuccess(result1.data);
            } else {
              this.error_text = result1.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        }
      }
      // Student login
      else {
        if(this.loginMethod === 'otp') {
          // OTP login
          loginByStudentV2(
            this.ruleForm2.email,
            this.ruleForm2.verify_code
          ).then((res) => {
            this.logining = false;
            let result = res.data;
            if (result.code == 0) {
              this.handleStudentLoginSuccess(result.data);
            } else {
              this.error_text = result.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        } else {
          // Password login
          loginByStudentWithPassword(
            this.ruleForm2.email,
            this.ruleForm2.password
          ).then((res) => {
            this.logining = false;
            let result = res.data;
            if (result.code == 0) {
              this.handleStudentLoginSuccess(result.data);
            } else {
              this.error_text = result.msg;
            }
          }).catch(() => {
            this.logining = false;
            this.error_text = "Network error. Please try again.";
          });
        }
      }
    },
    handleStudentLoginSuccess(data) {
      setUserId(data._id.$id);
      let account_country = "";
      if (data.account_country) {
        account_country = data.account_country;
      }
      setUserAccountCountry(account_country);
      const user_name =
        data.student_givenName_pinyin.charAt(0).toUpperCase() + data.student_givenName_pinyin.slice(1) + ' ' + data.student_lastName_pinyin.charAt(0).toUpperCase() + data.student_lastName_pinyin.slice(1);
      setUserName(user_name);
      setUserType("student");
      setAccountName(data.account_name)
      setAccountContinent(data.account_continent)
      setAccountId(data.account_id);
      this.$UserData.user_name = user_name;
      this.$UserData.account_country = account_country;
      this.$UserData.account_name = data.account_name;
      this.$UserData.account_continent = data.account_continent;
      this.$router.push("/home/news&updates");
    },
    handleAdvisorLoginSuccess(data) {
      setUserId(data._id.$id);
      let account_country = "";
      if (data.account_country) {
        account_country = data.account_country;
      }
      setUserAccountCountry(account_country);
      const user_name =
        data.contact_enName ? data.contact_enName : data.contact_givenName + ' ' + data.contact_lastName;
      setUserName(user_name);
      setUserType("advisor");
      setAccountId(data.account_id);
      setAccountName(data.account_nameEN);
      this.$UserData.user_name = user_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      this.$UserData.account_country = account_country;
      this.$UserData.account_name = data.account_nameEN;
      const account_continent = data.account_continent || "Asia";
      setAccountContinent(account_continent);
      this.$UserData.account_continent = account_continent;
      this.$router.push("/home/news&updates");
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.l-c {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url("~@/assets/image/loginBg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: 0 0;

  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    width: 40%;
    padding: 7%;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 60%;

    .login-form {
      display: flex;
      flex-direction: column;
      align-items: center;

      /deep/.el-input__inner {
        border-radius: 20px;
        background: #ffefed;
        border: 2px solid #ffe6e3;

        &::placeholder {
          color: #666666;
        }
      }

      /deep/.el-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        justify-content: flex-start;
      }

      /deep/.el-radio {
        margin-right: 15px;
        margin-bottom: 0;
      }
    }

    .logo {
      width: 50%;
      margin-bottom: 40px;
    }

    .title {
      margin: 0px auto 10px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }

    .el-radio {
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }

  // Mobile responsive styles
  @media (max-width: 768px) {
    .login-container {
      width: 90%;
      margin-left: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 5% 6%;
      max-height: 90vh;
      overflow-y: auto;

      .logo {
        width: 60%;
        margin-bottom: 20px;
      }
    }
  }

  @media (max-width: 480px) {
    .login-container {
      width: 95%;
      padding: 4% 5%;

      .logo {
        width: 70%;
        margin-bottom: 15px;
      }
    }
  }
}

.error_text {
  color: red;
}

/deep/ .el-input__suffix{
  right: 0;
}
.send_code{
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.help-links {
  width: 100%;
  text-align: right;
  margin-bottom: 15px;
  margin-top: -5px;
}

.help-link {
  color: #409EFF;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #66b1ff;
  }
}

.help-dialog-content {
  word-break: keep-all;
  overflow-wrap: break-word;

  ol {
    padding-left: 20px;
    margin: 15px 0;

    li {
      margin-bottom: 12px;
      line-height: 1.6;
    }
  }

  a {
    color: #409EFF;
    text-decoration: none;
    word-break: keep-all;

    &:hover {
      text-decoration: underline;
    }
  }
}

.forgot-password-content {
  word-break: keep-all;
  overflow-wrap: break-word;

  p {
    margin-bottom: 20px;
    color: #666;
    word-break: keep-all;
    overflow-wrap: break-word;
  }

  /deep/.el-form-item {
    margin-bottom: 18px;
  }

  /deep/.el-form-item__label {
    padding-bottom: 5px;
    word-break: keep-all;
    overflow-wrap: break-word;
  }
}

.terms-checkbox {
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;

  /deep/.el-checkbox {
    display: flex;
    align-items: flex-start;
    white-space: normal;
  }

  /deep/.el-checkbox__label {
    white-space: normal;
    line-height: 1.5;
    color: #606266;
    font-size: 13px;
  }

  /deep/.el-checkbox__input {
    margin-top: 3px;
  }

  .terms-link {
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #66b1ff;
    }
  }
}
</style>
